export const PublicBucket = 'media-bucket.letstok.com'
export const PrivateBucket = 'media-bucket-private.letstok.com'
